module.exports = __webpack_public_path__ + "static/img/our-people-company-values-hero.b9f1f39.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/our-people/our-people-company-values-hero.jpg
// module id = tPen
// module chunks = 0